import React from "react";

import { QFormControl, QMultiSelect } from "@qualio/ui-components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { elementStatus, ElementStatusTag } from "../domain/elementStatus";
import { BaseList } from "@design-controls/types";

const statusOptions = Object.keys(ElementStatusTag).map((item) => ({
  value: item,
  label: item,
}));

export const filterByStatus = (
  item: Pick<BaseList, "changeControlStatus" | "itemStatus">,
  value: readonly (string | null)[],
) => {
  return value.includes(elementStatus(item));
};

export const StatusFilter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Controller
      name="status"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t("filters.status")}>
          <QMultiSelect
            value={value}
            onChange={(selectedItem) =>
              onChange(selectedItem.map((item) => item.value))
            }
            options={statusOptions}
          />
        </QFormControl>
      )}
    />
  );
};
